import React from 'react';
import PropTypes from 'prop-types';

const PJNumberRenderer = ({ value }) => {
  const hasP = value && value.includes('P');
  return (
    <span className={hasP ? 'tw-text-amber-500 tw-font-semibold' : 'tw-text-blue-600 tw-font-semibold'}>
      {value}
    </span>
  );
};

PJNumberRenderer.propTypes = { value: PropTypes.string };

export default PJNumberRenderer;
